class PlanDescription {
  constructor(private readonly value: string = "") {
  }

  public toString(): string {
    return this.value;
  }
}

export default PlanDescription;
